import { render, staticRenderFns } from "./CommandModal.vue?vue&type=template&id=0bc540fb"
import script from "./CommandModal.vue?vue&type=script&lang=js"
export * from "./CommandModal.vue?vue&type=script&lang=js"
import style0 from "./CommandModal.vue?vue&type=style&index=0&id=0bc540fb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports